'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates a Form Button
 *
 * @class
 */

class FormButton extends Core {

    _defaults() {
        return {
            target: '.js-formbutton',
            fields: {
                'title': ""
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <a class='btn btn--m btn--background_base_borders'><%- title %></a>
        `;

        super.render();

        /**
         * Click
         *
         * @fires FormButton#_clicked
         */

         this.$el.on('click', this._clicked);
    }

    /**
     * @event FormButton#Cioui:Form:button:click
     * @property {String}Cioui:Form:button:click
     * @returns {String} value- the new text input obj
     */

    _clicked(e){
        $(e.currentTarget).trigger('Cioui:Form:button:click', $(e.currentTarget).val());
    }

}
module.exports = FormButton;